import { useParams, useSearchParams } from "next/navigation";

import { useStore } from "@/store";

export function useShowPublicProfile() {
  const searchParams = useSearchParams();
  const preview = !!searchParams.get("preview");
  const { teamPermalink } = useParams<{ [key: string]: string }>();

  const { doc, teams } = useStore();
  const currentPermalink = teamPermalink || doc?.team?.permalink;
  const teamIsOurs = !!teams.userTeams.find((userTeam) => userTeam.permalink === currentPermalink);
  const showPublicProfile =
    !!currentPermalink && (preview || (teams.userTeams.length > 0 && !teamIsOurs));

  return showPublicProfile;
}

/**
 * Whether to hide a doc's lock icon: visitors of a public profile can't edit its docs, so the
 * lock tells them nothing. It stays for a visitor who can write to the doc, unless the owner
 * is previewing their profile as the public sees it.
 */
export function useHideLockInPublicProfile(canWrite: boolean) {
  const preview = !!useSearchParams().get("preview");
  const showPublicProfile = useShowPublicProfile();
  const { auth } = useStore();
  const isPublicProfileView = !auth.isLoggedIn || showPublicProfile;

  return isPublicProfileView && (preview || !canWrite);
}
